import React from "react"

import { Typography } from "@material-ui/core"

const NotFound: React.FC = () => {
  return <Typography variant="h2">Not Found</Typography>
}

export default NotFound
